import React, { useContext, useEffect } from "react";
import { UserContext } from "../storage/contexts/UserContext";

const NotifySupportPersonModal = ({ isOpen, onClose, onSubmit }) => {
  const { profile } = useContext(UserContext);

  useEffect(() => {
    console.log("USER PROFILE: ", profile);
  }, [profile]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 transition-opacity duration-300">
      <div className="bg-white rounded-xl w-full max-w-sm mx-4 p-6 shadow-xl transform transition-all duration-300 scale-100">
        <div className="flex flex-col items-start">
          <h4 className="text-xl font-semibold text-left mb-2">
            Notify Support Person
          </h4>
          <p className="text-sm text-left text-black mb-4">
            Want someone to check-in with you? Tap a Support Person below, and
            we will notify them.
          </p>

          {profile?.supportPeople?.map((person, index) => (
            <div
              key={index}
              onClick={() => onSubmit(person)}
              className="w-full flex flex-row justify-start items-center border-indigo-600 border text-black py-2 px-4 rounded-xl mb-2 hover:bg-indigo-700 hover:text-white transition-all"
            >
              <img
                className="h-10 w-10 object-cover rounded-full"
                src={person?.profileImage ?? ""}
              />
              <p className="ml-3 font-medium">
                {person?.firstname ?? ""} {person?.lastname ?? ""}
              </p>
            </div>
          ))}

          <button
            onClick={() => {
              onClose();
            }}
            className="w-full text-sm bg-gray-200 text-gray-800 py-2 px-4 rounded-lg mt-2 hover:bg-gray-300 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotifySupportPersonModal;
